import axios from 'axios'
import config from '../config'

const MemberGift = {
    state: {
        memberGift: [],
        error: false,
        msg: ''
    },
    mutations:{
        MemberGift: (state, memberGift) => state.memberGift = memberGift,
        ERROR: (state, error) => state.error = error,
        MSG: (state, msg) => state.msg = msg
    },
    actions: {
        async addMemberGift({commit}, data){
            await axios({
                method:'post',
                url: config.ADD_POINT_GIFT,
                data: data
            })
            .then((result) => {
                commit('ERROR', result.data.error)
                commit('MSG', result.data.msg)
            }).catch((err) => {
                console.log(err);
            });
        },
        async updateMemberGift({commit}, data){
            await axios({
                method:'post',
                url: config.UPDATE_POINT_GIFT,
                data:data
            })
            .then((result) => {
                commit('ERROR', result.data.error)
                commit('MSG', result.data.msg)
            }).catch((err) => {
                console.log(err);
            });
        },
        async fetchMemberGift({commit}, data){
            await axios({
                method:'post',
                url: config.LOAD_POINT_GIFT_LIST,
                data: data
            })
            .then((result) => {
                commit('MemberGift', result.data.results)
            }).catch((err) => {
                console.log(err);
            });
        },
        async deleteMemberGift({commit}, data){
            await axios({
                method:'delete',
                url: config.DELETE_POINT_GIFT,
                data: data
            })
            .then((result) => {
                commit('ERROR', result.data.error)
                commit('MSG', result.data.msg)
            }).catch((err) => {
                console.log(err);
            });
        }
    },
    getters: {
        getMemberGiftList: state => state.memberGift,
        getMemberGiftError: state => state.error,
        getMemberGiftMsg: state => state.msg
    },
}

export default MemberGift;